import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { idFetcher } from "../../utilities/fetcher";

export default function VideoPlayer({ urls }: { urls: string[] }) {
  const [sources, setSources] = useState<string[]>([]);

  const { getIdTokenClaims } = useAuth0();

  useEffect(() => {
    if (!urls || !getIdTokenClaims) return;

    (async () => {
      setSources(
        await Promise.all(
          urls.map(async (url) => {
            if (url.startsWith("https://")) {
              return url;
            } else {
              const response = await idFetcher(
                `/api/s3/get/${url}`,
                getIdTokenClaims
              );
              if (!response)
                return console.error(
                  "unable to retrieve presigned url for",
                  url
                );
              return response.signedUrl;
            }
          })
        )
      );
    })();
  }, [...urls, getIdTokenClaims]);

  // const vidSnap = useCallback((v: any) => {
  //   const video = v.target as HTMLVideoElement;
  //   // video.currentTime = 10;
  //   const canvas = document.createElement("canvas");
  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;
  //   const context = canvas.getContext("2d");
  //   if (!context) {
  //     video.currentTime = 0;
  //     return;
  //   }
  //   context.drawImage(video, 0, 0, canvas.width, canvas.height);
  //   video.poster = canvas.toDataURL();
  //   video.currentTime = 0;
  // }, []);

  return (
    <>
      {sources ? (
        <video controls preload="metadata">
          {sources.map((src: string) => (
            <source key={src} src={src} />
          ))}
        </video>
      ) : null}
    </>
  );
}
